import { BuildGridButton, ComboList, FormType } from "@siu/shared";
import { ISolicitud } from "src/app/modules/autorizaciones/interfaces/autorizacion.interface";
import { TipoAutorizacionEnum } from "../models/autorizaciones.model";
import {
  EstadoSolicitudEnum,
  IFormBuscarSolicitudes,
  IFormularioBuscarSolicitud,
  IModalAutorizacionConsulta,
  IModalCargoAutorizacionConsulta,
  IModalCronogramaConsulta,
  IModalSubsanadoConsulta,
} from "./autorizacion.consultar.interface";

export class CrudStoreModel {}

export class FormBuscarSolicitud implements IFormBuscarSolicitudes {
  eIdTipoAutorizacion = null;
  FK_eIdSolicitudEstado = null;
  fFechaSolicitud = null;
  fFechaSolicitudDesde = null;
  fFechaSolicitudHasta = null;
  cUbigeoOrigen = null;
  cUbigeoDestino = null;
  eIdEmpresa = null;
}

export class Solicitud implements ISolicitud {
  idSolicitud = null;
  idItinerario = null;
  idTipoAutorizacion = null;
  idTipoDocumentoEmpresa = null;
  idConfVehicular = null;
  idEmpresa = null;
  nombreEmpresa = null;
  registroMTC = null;
  rdInternacional = null;
  numDocumentoEmpresa = null;
  representanteLegal = null;
  esInternacional = null;
  numSolicitud = null;
  idExpediente = null;
  tipoAutorizacion = null;
  fechaSolicitud = null;
  apoyoPolicial = null;
  numVehiculoEscolta = null;
  largoTotal = null;
  anchoTotal = null;
  altoTotal = null;
  pesoTotal = null;
  idAprobador = null;
  aprobador = null;
  fechaAprobacion = null;
  idEstadoAutorizacion = null;
  fechaVigenciaDesde = null;
  fechaVigenciaHasta = null;
  numSecuencia = null;
  codigoCaja = null;
  fechaMovimiento = null;
  idEstado = null;
  idEstadoUsuarioRegistro = null;
  fechaRegistro = null;
  idUsuarioActualizacion = null;
  fechaActualizacion = null;

  fechaSolicitudDesde = null;
  fechaSolicitudHasta = null;

  departamentoOrigen = null;
  provinciaOrigen = null;
  distritoOrigen = null;
  departamentoDestino = null;
  provinciaDestino = null;
  distritoDestino = null;
}

export class FormularioBuscarSolicitudModel
  implements IFormularioBuscarSolicitud
{
  error = null;
  isLoading = false;
  type = FormType.BUSCAR;
  solicitud = new Solicitud();
  formBuscar = new FormBuscarSolicitud();
  modalAutorizacionConsulta = new ModalAutorizacionConsulta();
  modalCronogramaConsulta = new ModalCronogramaConsulta();
  modalSubsanadoConsulta = new ModalSubsanadoConsulta();
  modalCargoAutorizacionConsulta = new ModalCargoAutorizacionConsulta();
  filterLists = {
    tipoAutorizacion: new ComboList([]),
    estados: new ComboList([]),
    listDepartamentoOrigen: new ComboList([]),
    listProvinciaOrigen: new ComboList([]),
    listDistritoOrigen: new ComboList([]),
    listDepartamentoDestino: new ComboList([]),
    listProvinciaDestino: new ComboList([]),
    listDistritoDestino: new ComboList([]),
  };
  definition = {
    columns: [
      { label: "", field: "open-expandable", template: "open-expandable" },
      { label: "Cod. Expediente", field: "cCodigoExpediente" },
      { label: "Tipo Autorización", field: "cTipoAutorizacion" },
      { label: "Origen", field: "oItinerario.cUbigeoDescOrigen" },
      { label: "Destino", field: "oItinerario.cUbigeoDescDestino" },
      { label: "Largo Total (m)", field: "dLargoTotal" },
      { label: "Ancho Total (m)", field: "dAnchoTotal" },
      { label: "Alto Total (m)", field: "dAltoTotal" },
      { label: "Peso Total (kg)", field: "dPesoTotal" },
      { label: "Fecha Solicitud", field: "fFechaSolicitud", isDatetime: true },
      { label: "Estado", field: "cSolicitudEstado" },
      {
        label: "Acciones",
        field: "buttons",
        buttons: [
          BuildGridButton.CONSULTAR(),
          BuildGridButton.EDITAR(
            () => {
              return false;
            },
            (item) => {
              return (
                item.fK_eIdSolicitudEstado == EstadoSolicitudEnum.APROBADO ||
                item.fK_eIdSolicitudEstado ==
                  EstadoSolicitudEnum.NO_PRESENTADO ||
                item.fK_eIdSolicitudEstado == EstadoSolicitudEnum.ENVIADO ||
                item.fK_eIdSolicitudEstado == EstadoSolicitudEnum.OBSERVADO ||
                item.fK_eIdSolicitudEstado ==
                  EstadoSolicitudEnum.OBSERVADO_SUBSANADO ||
                item.fK_eIdSolicitudEstado ==
                  EstadoSolicitudEnum.APROBADO_SUBSANACION ||
                item.fK_eIdSolicitudEstado ==
                  EstadoSolicitudEnum.APROBADO_APELACION ||
                item.fK_eIdSolicitudEstado ==
                  EstadoSolicitudEnum.RECHAZADO_SUBSANACION ||
                item.fK_eIdSolicitudEstado ==
                  EstadoSolicitudEnum.RECONSIDERACION_EN_PROCESO
              );
            }
          ),
          BuildGridButton.ELIMINAR(
            () => {
              return false;
            },
            (item) => {
              return (
                item.fK_eIdSolicitudEstado == EstadoSolicitudEnum.APROBADO ||
                item.fK_eIdSolicitudEstado == EstadoSolicitudEnum.ENVIADO ||
                item.fK_eIdSolicitudEstado == EstadoSolicitudEnum.OBSERVADO ||
                item.fK_eIdSolicitudEstado ==
                  EstadoSolicitudEnum.OBSERVADO_SUBSANADO ||
                item.fK_eIdSolicitudEstado ==
                  EstadoSolicitudEnum.APROBADO_SUBSANACION ||
                item.fK_eIdSolicitudEstado ==
                  EstadoSolicitudEnum.APROBADO_APELACION ||
                item.fK_eIdSolicitudEstado ==
                  EstadoSolicitudEnum.RECHAZADO_SUBSANACION ||
                item.fK_eIdSolicitudEstado ==
                  EstadoSolicitudEnum.RECONSIDERACION_EN_PROCESO
              );
            }
          ),
          BuildGridButton.UPDATECRONOGRAMA(
            () => {
              return false;
            },
            (item) => {
              return !(
                item.fK_eIdSolicitudEstado !==
                  EstadoSolicitudEnum.NO_PRESENTADO &&
                item.fK_eIdSolicitudEstado !== EstadoSolicitudEnum.EN_PROCESO &&
                item.fK_eIdSolicitudEstado !== EstadoSolicitudEnum.OBSERVADO &&
                item.fK_eIdSolicitudEstado !== EstadoSolicitudEnum.ENVIADO &&
                item.fK_eIdSolicitudEstado !==
                  EstadoSolicitudEnum.OBSERVADO_SUBSANADO &&
                item.fK_eIdSolicitudEstado !==
                  EstadoSolicitudEnum.RECHAZADO_RECONSIDERACION &&
                item.fK_eIdSolicitudEstado !==
                  EstadoSolicitudEnum.RECHAZADO_SUBSANACION &&
                item.fK_eIdTipoAutorizacion !== TipoAutorizacionEnum.AAM &&
                item.fK_eIdTipoAutorizacion !== TipoAutorizacionEnum.ABM &&
                item.fK_eIdTipoAutorizacion !== TipoAutorizacionEnum.ACM &&
                item.fK_eIdTipoAutorizacion !== TipoAutorizacionEnum.ADM &&
                item.eNumCronogramaUpdated == 0
              );
            }
          ),
          BuildGridButton.SUBSANARREQUISITO(
            () => {
              return false;
            },
            (item) => {
              return !(
                item.fK_eIdSolicitudEstado !==
                  EstadoSolicitudEnum.NO_PRESENTADO &&
                item.fK_eIdSolicitudEstado !== EstadoSolicitudEnum.EN_PROCESO &&
                item.fK_eIdSolicitudEstado !== EstadoSolicitudEnum.ENVIADO &&
                item.fK_eIdSolicitudEstado !==
                  EstadoSolicitudEnum.OBSERVADO_SUBSANADO &&
                item.fK_eIdSolicitudEstado !== EstadoSolicitudEnum.APROBADO &&
                item.fK_eIdSolicitudEstado !==
                  EstadoSolicitudEnum.APROBADO_SUBSANACION &&
                item.fK_eIdSolicitudEstado !==
                  EstadoSolicitudEnum.RECHAZADO_RECONSIDERACION &&
                item.fK_eIdSolicitudEstado !==
                  EstadoSolicitudEnum.RECHAZADO_SUBSANACION &&
                item.fK_eIdSolicitudEstado !==
                  EstadoSolicitudEnum.RECONSIDERACION_EN_PROCESO
              );
            }
          ),
          BuildGridButton.DESCARGAR(
            () => {
              return false;
            },
            (item) => {
              return (
                item.fK_eIdSolicitudEstado !== EstadoSolicitudEnum.APROBADO &&
                item.fK_eIdSolicitudEstado !==
                  EstadoSolicitudEnum.APROBADO_SUBSANACION
              );
            }
          ),
        ],
      },
    ],
  };
  gridSource = {
    items: [],
    page: 1,
    pageSize: 25,
    total: 0,
    skip: 0,
    orderBy: "PK_eIdSolicitud",
    orderDir: "DESC",
  };
}

export class ModalAutorizacionConsulta implements IModalAutorizacionConsulta {
  title = "Consulta de Autorización";
  isLoading = false;
  error = null;
  type = FormType.CONSULTAR;

  idSolicitud = null;
  solicitud = null;
}

export class ModalCronogramaConsulta implements IModalCronogramaConsulta {
  title = "Consulta de Cronograma";
  isLoading = false;
  error = null;
  type = FormType.CONSULTAR;

  idSolicitud = null;
  idDocumento = null;
  solicitud = null;
  cronograma = null;
}

export class ModalSubsanadoConsulta implements IModalSubsanadoConsulta {
  title = "Consulta de Solicitud Subsanada";
  isLoading = false;
  error = null;
  type = FormType.CONSULTAR;

  idSolicitud = null;
  idDocumento = null;
  solicitud = null;
  subsanado = null;
}

export class ModalCargoAutorizacionConsulta
  implements IModalCargoAutorizacionConsulta
{
  title = "Consulta del Cargo de Autorización";
  isLoading = false;
  error = null;
  type = FormType.CONSULTAR;
  solicitudSeleccionada = null;
}

export const buildNewModalAutorizacionConsulta =
  (): IModalAutorizacionConsulta => ({
    title: "Consulta de Autorización",
    error: null,
    isLoading: false,
    type: FormType.CONSULTAR,
    idSolicitud: null,
    solicitud: null,
  });

export const buildNewModalCronogramaConsulta =
  (): IModalCronogramaConsulta => ({
    title: "Consulta de Cronograma",
    error: null,
    isLoading: false,
    type: FormType.CONSULTAR,
    idSolicitud: null,
    idDocumento: null,
    solicitud: null,
    cronograma: null,
  });

export const buildNewModalSubsanadoConsulta = (): IModalSubsanadoConsulta => ({
  title: "Consulta de Solicitud Subsanada",
  error: null,
  isLoading: false,
  type: FormType.CONSULTAR,
  idSolicitud: null,
  idDocumento: null,
  solicitud: null,
  subsanado: null,
});
